import { render, staticRenderFns } from "./leTabs.vue?vue&type=template&id=539b4435&scoped=true"
import script from "./leTabs.vue?vue&type=script&lang=js"
export * from "./leTabs.vue?vue&type=script&lang=js"
import style0 from "./leTabs.vue?vue&type=style&index=0&id=539b4435&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b4435",
  null
  
)

export default component.exports